UTIL.registerTask('checkout', 'confirm', function() {
    (function ($) {
        /**
         * Below is a loop to confirm IPN has been receive and order completed
         */
        if ($("#confirm-payment").length) {
            var loopTimer;
            var loopCount = 0;

            loopTimer = setInterval(function () {
                confirmOrderCompleted();
            }, 1000);

            function confirmOrderCompleted() {
                clearInterval(loopTimer);

                if (loopCount >= 20) window.location.replace(ab.redirect);

                $.ajax(ab.apiUrl + "/orders/" + ab.orderNumber + "/completed", {
                    method: "GET"
                }).success(function () {
                    window.location.replace(ab.redirect);
                }).fail(function (error) {
                    loopTimer = setInterval(function () {
                        confirmOrderCompleted();
                    }, 1000);
                });

                loopCount += 1;
            }
        }
    })(jQuery);
});